import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sw',
    fullName: 'Swahili',
    nativeName: 'Kiswahili',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Kitu cha Kushangaza kinakuja",
    landing_subtitle: "ArgVoid ni programu na studio ya ukuzaji wa mchezo. Endelea kuwa nasi, mambo mapya yanakuja hivi karibuni!",
    select_language: "Chagua Lugha",
    search_placeholder: "Tafuta lugha...",
    terms_title: "Masharti ya Huduma",
    policy_title: "Sera ya Faragha",
    cookies_title: "Sera ya Vidakuzi",
    terms_content: `
        <strong>1. Kukubalika kwa Masharti</strong><br>
        Kwa kufikia ArgVoid, Sheria na Masharti haya yanakubaliwa. Masharti haya yasipokubaliwa, huduma haifai kutumika.<br><br>

        <strong>2. Matumizi ya Jukwaa</strong>X<br>
        ArgVoid na matumizi yake hutolewa "kama ilivyo" kwa madhumuni ya habari na ubunifu. Huduma lazima itumike kwa madhumuni halali pekee.<br>X<br>

        <strong>3. Mwenendo uliopigwa marufuku</strong><br>
        Kutumia udhaifu wa tovuti, kutuma barua taka, au kujaribu ufikiaji usioidhinishwa kwa miundombinu ni marufuku kabisa.<br><br>

        <strong>4. Kanusho</strong><br>
        Jukwaa na huduma zinaweza kurekebishwa wakati wowote bila taarifa. Hakuna udhamini unaotolewa kuhusu uptime au upatikanaji wa huduma.
    `,
    policy_content: `
        <strong>1. Mkusanyiko wa Habari</strong>X<br>
        Mfumo hauhitaji uthibitishaji wa mtumiaji au kuunda akaunti kwa wakati huu. Hakuna taarifa za kibinafsi za utambulisho (kama vile majina au anwani za barua pepe) zinazokusanywa kikamilifu kutoka kwa wageni.<br><br>

        <strong>2. Data ya matumizi</strong>X<br>
        Uchanganuzi wa kimsingi, usiojulikana unaweza kukusanywa ili kuelewa trafiki ya tovuti na kuboresha programu. Data hii haijaunganishwa na utambulisho wa mtumiaji binafsi.<br>X<br>

        <strong>3. Huduma za Wahusika wengine</strong><br>
        Watoa huduma wengine wanaweza kutumika kwa huduma za upangishaji na uchanganuzi. Mbinu za faragha za watoa huduma hawa hutawala data isiyojulikana iliyochakatwa kwenye miundombinu yao.<br><br>

        <strong>4. Usalama wa Data</strong><br>
        Hatua zinazofaa za usalama zinatekelezwa ili kulinda jukwaa. Hata hivyo, hakuna njia ya uwasilishaji kwenye Mtandao iliyo salama kabisa.<br><br>
    `,
    cookies_content: `
        <strong>1. Vidakuzi na Hifadhi ya Ndani ni nini?</strong><br>
        Vidakuzi na hifadhi ya ndani ya kivinjari ni faili ndogo za data zilizohifadhiwa kwenye kifaa ili kukumbuka mapendeleo ya usanidi katika ziara zote.<br><br>

        <strong>2. Matumizi Purpose</strong>X<br>
        Uhifadhi wa Ndani wa Kivinjari hutumiwa kikamilifu kuhifadhi mipangilio ya usanidi, kama vile:<br>
        - Mapendeleo ya lugha<br>
        - Usanidi wa kiolesura cha mtumiaji (k.m., mpangilio au mipangilio ya mandhari)<br>
        - Cache ya maombi ya muda<br><br>

        <strong>3. Hakuna Tracking</strong><br>
        Vidakuzi na hifadhi ya ndani haitumiki kwa madhumuni ya utangazaji au ufuatiliaji wa watu wengine. Data yote iliyohifadhiwa ni madhubuti ya utendakazi wa msingi wa jukwaa.<br><br>

        <strong>4. Udhibiti </strong><br>
        Data ya kivinjari inaweza kufutwa wakati wowote kupitia mipangilio ya kivinjari, ambayo itaweka upya usanidi wowote wa ndani.
    `,
    cookie_consent_text: "Tunatumia vidakuzi vya msingi ili kuhakikisha kuwa tovuti inafanya kazi ipasavyo, kama vile kuweka kipindi chako kikitumika, kuhifadhi mapendeleo yako ya lugha na usanidi mwingine maalum.",
    read_policy: "Soma Sera ya Vidakuzi",
    support_title: "Wasiliana na Usaidizi",
    support_subject_label: "Somo",
    support_message_label: "Ujumbe",
    support_submit_button: "Tuma Ujumbe",
    support_hint: "Kumbuka: Hii itafungua programu yako chaguomsingi ya barua pepe kutuma ujumbe.",
    support_success_msg: "Inafungua programu yako ya barua pepe...",
    support_error_msg: "Imeshindwa kutuma ujumbe. Tafadhali jaribu tena baadaye.",
    explorer_title: "Mchunguzi",
    history_title: "Historia",
    animation_title: "Uhuishaji",
    config_title: "Usanidi",
    tool_mouse: "Chagua (Ctrl+M)",
    tool_brush: "Brashi (Ctrl+B)",
    tool_brush_mode: "Hali ya Kugeuza (Imara/Wazi)",
    tool_eraser: "Kifutio (Ctrl+E)",
    tool_brush_size: "Rekebisha Ukubwa wa Brashi",
    tool_bucket: "Jaza (Ctrl+F)",
    tool_eyedropper: "Mtoa macho",
    tool_grid: "Gridi (Ctrl+Shift+B)",
    tool_rotate: "Zungusha (Ctrl+Shift+R)",
    tool_flip_h: "Geuza H (Ctrl+Shift+H)",
    tool_flip_v: "Geuza V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Upana",
    label_height: "Urefu",
    label_frames: "Idadi ya Fremu",
    label_animation: "Mtindo wa Uhuishaji",
    label_background_color: "Rangi ya Mandharinyuma",
    label_interval: "Muda",
    tool_anim_config: "Usanidi wa Uhuishaji",
    label_new_width: "Upana Mpya",
    label_new_height: "Urefu Mpya",
    label_apply: "Omba",
    label_colors: "Rangi",
    label_size: "Ukubwa",
    label_tolerance: "Uvumilivu",
    val_horizontal: "Mlalo",
    val_vertical: "Wima",
    val_sequence: "Mfuatano",
    val_bounce: "Bounce",
    val_random: "Nasibu",
    val_solid: "Imara",
    val_clear: "Wazi",
    action_add_sheet: "Laha Mpya",
    action_import: "Ingiza",
    action_export: "Hamisha",
    action_sort_projects: "Panga",
    sort_date_old: "Mzee Kwanza",
    sort_date_new: "Mpya Zaidi Kwanza",
    sort_name_az: "Jina (A-Z)",
    sort_name_za: "Jina (Z-A)",
    action_new_sprite: "Sprite Mpya",
    action_new_project: "Mradi Mpya",
    modal_save_all_title: "Hifadhi Mabadiliko Yote",
    modal_save_all_desc: "Chagua vipengee vya kuhifadhi:",
    modal_save_selected: "Hifadhi Imechaguliwa",
    action_saved: "Imehifadhiwa",
    modal_create_sprite_title: "Unda Sprite Mpya",
    modal_create_project_title: "Unda Mradi Mpya",
    modal_add_sheet_title: "Ongeza Laha Mpya",
    modal_rename_sheet_title: "Badilisha Jina la Laha",
    modal_rename_sprite_title: "Badilisha jina Sprite",
    modal_delete_sprite_title: "Futa Sprite",
    modal_delete_project_title: "Futa Mradi",
    modal_delete_sheet_title: "Futa Laha",
    placeholder_sprite_name: "Jina",
    placeholder_project_name: "Jina",
    placeholder_sheet_name: "Jina",
    placeholder_new_name: "Jina Jipya",
    action_create: "Unda",
    action_add: "Ongeza",
    action_rename: "Badilisha jina",
    action_duplicate: "Nakala",
    action_delete: "Futa",
    action_cancel: "Ghairi",
    confirm_delete_sprite: "Je, una uhakika unataka kufuta sprite hii?",
    confirm_delete_project: "Je, una uhakika unataka kufuta mradi huu? Sprites zote zitaondolewa.",
    confirm_delete_sheet: "Je, una uhakika unataka kufuta laha hii?",
    err_select_sprite: "Tafadhali chagua sprite kwanza.",
    err_select_project: "Tafadhali chagua mradi kwanza.",
    err_name_empty: "Jina haliwezi kuwa tupu.",
    err_sprite_exists: "Sprite yenye jina hilo tayari ipo.",
    err_project_exists: "Mradi wenye jina hilo tayari upo.",
    err_no_content: "Hakuna maudhui ya kuhifadhi.",
    err_no_changes: "Hakuna mabadiliko ya kuhifadhi.",
    err_delete_last_sheet: "Haiwezi kufuta laha ya mwisho.",
    err_extract_frames: "Haikuweza kutoa fremu zozote.",
    err_indexeddb: "Imeshindwa kuhifadhi ndani ya nchi. Kivinjari chako kinaweza kisiauni IndexedDB.",
    msg_upload_success: "Upakiaji Umefaulu: {0}",
    msg_upload_failed: "Imeshindwa Kupakia: {0}",
    msg_save_success: "Imefaulu kuhifadhi.",
    msg_saving: "Inahifadhi...",
    msg_multi_save_result: "Imehifadhi mali {0}. {1} kushindwa.",
    menu_title: "Menyu",
    menu_save: "Hifadhi",
    menu_save_all: "Okoa Zote",
    menu_support: "Wasiliana na Usaidizi",
    label_local_storage: "Hifadhi ya Ndani",
    label_sign_in: "Ingia",
    modal_export_title: "Hamisha Sprite",
    label_filename: "Jina la faili",
    label_format: "Umbizo",
    action_export_confirm: "Hamisha",
};

export default translations;
